export const BUNDLE_OPTIONS = [
  { count: 1, discount: 0 },
  { count: 2, discount: 0.247 },
  { count: 4, discount: 0.30 },
  { count: 6, discount: 0.349 },
];

export const toNumericPrice = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') {
    const normalized = value.replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return normalized ? Number(normalized[0]) : 0;
  }
  return 0;
};

export const formatBundlePrice = (value) => {
  if (!Number.isFinite(value)) return '0';
  return new Intl.NumberFormat(undefined, {
    maximumFractionDigits: Number.isInteger(value) ? 0 : 2,
  }).format(value);
};

export const getBundlePricing = (course, selectedBundle = 1) => {
  const option = BUNDLE_OPTIONS.find(({ count }) => count === selectedBundle) || BUNDLE_OPTIONS[0];
  const numericCostBefore = toNumericPrice(course?.costBefore);
  const numericCostAfter = toNumericPrice(course?.costAfter);
  const hasCourseDiscount = numericCostBefore > 0 && numericCostBefore > numericCostAfter;
  const originalSinglePrice = numericCostBefore || numericCostAfter;
  const discountedSinglePrice = hasCourseDiscount ? numericCostAfter : originalSinglePrice;
  const originalTotal = originalSinglePrice * option.count;
  const isSingleLevel = option.count === 1;
  const displayedDiscountPercent = isSingleLevel
    ? Math.round(((originalSinglePrice - discountedSinglePrice) / originalSinglePrice) * 100) || 0
    : option.discount * 100;
  const discountedTotal = isSingleLevel ? discountedSinglePrice : originalTotal * (1 - option.discount);

  return {
    selectedBundle: option.count,
    originalSinglePrice,
    originalTotal,
    discountedTotal,
    perLevelPrice: discountedTotal / option.count,
    discountPercent: displayedDiscountPercent,
    hasDiscount: displayedDiscountPercent > 0,
  };
};

export const withBundleSelection = (course, selectedBundle = 1) => {
  const pricing = getBundlePricing(course, selectedBundle);

  return {
    ...course,
    selectedBundle: pricing.selectedBundle,
    bundleOriginalTotal: pricing.originalTotal,
    bundleDiscountedTotal: pricing.discountedTotal,
    bundlePerLevelPrice: pricing.perLevelPrice,
    bundleDiscountPercent: pricing.discountPercent,
  };
};

const getBundleStorageKey = (courseID) => `course_bundle_${courseID}`;

export const getStoredBundleSelection = (courseID, fallback = 6) => {
  try {
    const stored = Number(sessionStorage.getItem(getBundleStorageKey(courseID)));
    return BUNDLE_OPTIONS.some(({ count }) => count === stored) ? stored : fallback;
  } catch {
    return fallback;
  }
};

export const storeBundleSelection = (courseID, selectedBundle) => {
  try {
    sessionStorage.setItem(getBundleStorageKey(courseID), String(selectedBundle));
  } catch {}
};
